import { useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { use3YearsVision } from '../../hooks/onboarding/use3YearsVision';
import bg from '../../assets/bg-register.jpg'; // Change this line to match HomePage

export const OnboardingSummaryPage = () => {
  const navigate = useNavigate();
  const { profile, isLoading, error, refetch } = use3YearsVision();

  const renderVisionContent = () => {
    if (isLoading) {
      return (
        <div className="flex justify-center py-8">
          <Loader2 className="w-6 h-6 text-[#5CD2F4] animate-spin" />
        </div>
      );
    }

    if (error) {
      return (
        <div className="text-center py-4">
          <p className="text-red-400 text-sm mb-2">Failed to load your vision</p>
          <button
            onClick={refetch}
            className="text-[#5CD2F4] text-sm hover:underline"
          >
            Try again
          </button>
        </div>
      );
    }

    if (!profile?.threeYearSummary) {
      return (
        <div className="text-center py-4">
          <p className="text-gray-400 text-sm mb-2">No vision set yet</p>
          <button
            onClick={() => navigate('/chat-onboarding')}
            className="text-[#5CD2F4] text-sm hover:underline"
          >
            Create your 3-year vision
          </button>
        </div>
      );
    }

    return (
      <p className="text-sm text-white font-montserrat">
        {profile.threeYearSummary}
      </p>
    );
  };

  return (
    <div
      className="bg-[#1a1a1a] flex flex-col relative h-screen bg-cover bg-center bg-no-repeat" // Also update background color to match
      style={{ backgroundImage: `url(${bg})` }}
    >
      <main className="w-full max-w-sm sm:max-w-md md:max-w-lg lg:max-w-xl mx-auto px-3 sm:px-4 md:px-6 py-4 sm:py-6 space-y-6 flex-1 flex flex-col justify-center">


        <div className="text-center space-y-2">
          <div className="text-normal font-montserrat font-medium mb-6">
            <h1 className="text-2xl font-bold">
              <span className="bg-gradient-to-br from-[#79c9cb] to-[#4b7bdd] bg-clip-text text-transparent">
                {profile?.name ? `${profile.name}'s 3-Year Vision` : 'Your 3-Year Vision'}
              </span>
            </h1>
          </div>
          {renderVisionContent()}
        </div>

        <div className="flex flex-col items-center space-y-1">
          <button
            onClick={() => navigate('/chat-onboarding')}
            className="bg-gradient-to-br from-[#79c9cb] to-[#4b7bdd] text-white py-3 px-8 rounded-3xl font-semibold hover:opacity-90 transition-opacity mb-1"
          >
            Update Your 3-Year Vision
          </button>

        </div>

        <div className="space-y-2">


        </div>
      </main>
    </div>
  );
};